import { api } from "./api";

export const countriesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query({
      query: () => "api/Sys/Countries",
      providesTags: ["countries"],
    }),
    addCountry: builder.mutation({
      query: (formData) => ({
        url: "api/Sys/Countries",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["countries"],
    }),
    editCountry: builder.mutation({
      query: (formData) => ({
        url: "api/Sys/Countries",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["countries"],
    }),
    deleteCountry: builder.mutation({
      query: (countryId) => ({
        url: `api/Sys/Countries?CountryID=${countryId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["countries"],
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useAddCountryMutation,
  useEditCountryMutation,
  useDeleteCountryMutation,
} = countriesApi;
